import React, {useEffect, useState} from 'react';

import './ClientVaultCreate.scss';
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import VaultForm from "../VaultForm/VaultForm";
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import {Helmet} from "react-helmet";
import routes from "../../utils/api-client";
import VaultCreate from "../VaultCreate/VaultCreate";

function ClientVaultCreate(props) {

  let [client, setClient] = useState(null);


  useEffect(() => {
    if (props.user) {
      props.toggleLoading(true);
      routes.getClient(props.clientId).subscribe((response) => {
        setClient(response.data)
        props.toggleLoading(false);
      });
    }
  }, [props.user]);

  return client && <VaultCreate client={client}/>;
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading }
  )
)(ClientVaultCreate);
